import { render } from "./ItemCard.vue?vue&type=template&id=6b494494&scoped=true"
import script from "./ItemCard.vue?vue&type=script&lang=js"
export * from "./ItemCard.vue?vue&type=script&lang=js"

import "./ItemCard.vue?vue&type=style&index=0&id=6b494494&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b494494"]])

export default __exports__